import request from '../main';
const service = ""
class StatisticApi {
    private url: string = service + "/statistics";

    public listAuditInstrSummary(args: any){
        return request({
            url: this.url + '/list-audit-instr-summary',
            method: 'get',
            params: args
        })
    }

    public listAuditOrderSummary(args: any){
        return request({
            url: this.url + '/list-audit-order-summary',
            method: 'get',
            params: args
        })
    }


    public listAuditOrderApp(args: any){
        return request({
            url: this.url + '/list-audit-order-app',
            method: 'get',
            params: args
        })
    }

    public listAuditInstrApp(args: any){
        return request({
            url: this.url + '/list-audit-instr-app',
            method: 'get',
            params: args
        })
    }

    public listInspectOrderApp(args: any){
        return request({
            url: this.url + '/list-inspect-order-app',
            method: 'get',
            params: args
        })
    }

    public listInspectInstrApp(args: any){
        return request({
            url: this.url + '/list-inspect-instr-app',
            method: 'get',
            params: args
        })
    }

    public listInspectInstrAppGroupByMechanism(args: any){
        return request({
            url: this.url + '/list-inspect-instr-app-group-by-mechanism',
            method: 'get',
            params: args
        })
    }

    public listInspectInstrAppGroupByCatalogue(args: any){
        return request({
            url: this.url + '/list-inspect-instr-app-group-by-catalogue',
            method: 'get',
            params: args
        })
    }

    public listAcceptInspectInstrStatis(args: any){
        return request({
            url: this.url + '/list-accept-inspect-instr-statis',
            method: 'get',
            params: args
        })
    }

    public getMechanismRegion(){
        return request({
            url: this.url + '/get-mechanism-region',
            method: 'get',
        })
    }

    public getMechanismWorkStatis(args: any){
        return request({
            url: this.url + '/get-mechanism-work-statis',
            method: 'get',
            params: args
        })
    }


    public export(){
        return request({
            url: this.url + '/export',
            method: 'get',
        })
    }
    //专报
    public exportZB(){
        return request({
            url: this.url + '/export-zhuan-bao',
            method: 'get',
        })
    }

    public listStatisticalData(region: string){
        return request({
            url: this.url + '/list-statistical-data',
            method: 'get',
            params: {
                region: region
            }
        })
    }

    public listPromiseStatis(args: any){
        return request({
            url: this.url + '/list-promise-statis',
            method: 'get',
            params: args
        })
    }

}
const statisticApi = new StatisticApi();
export default statisticApi
